﻿// Fonts
require("@cirrus/legacy/vendor-bower/components-font-awesome/css/font-awesome.css")
require("@cirrus/assets/font-opensans/css/style.css")
